export default function extractOutletCode(url, outlets) {
    try {
      const hostname = new URL(url).hostname.replace(/^www\./, "");
      const match = Object.keys(outlets).find((key) => hostname.includes(key));
      return match || "unknown";
    } catch {
      return "unknown";
    }
  }